import { Component } from "@angular/core";

@Component({
  selector: "app-cms",
  templateUrl: "./cms.component.html",
})
export class CmsComponent {}
